import type { IPlan } from '~/types/plan.interface'

export const usePlan = defineStore('plan', () => {
  const runtimeConfig = useRuntimeConfig()

  const planId = ref<string | undefined>()

  const selectedPlan = computed<IPlan.DayPlan | undefined>(() => {
    if (!plans?.value) { return undefined }
    return plans?.value.find(plan => plan.planId === planId.value)
  })

  const dataType = ref<IPlan.DataType>()

  const router = useRouter()

  const partner = computed(() => router.currentRoute.value.params.partner as string)

  watch(() => router.currentRoute.value.params, (newVal) => {
    if (newVal.planId) {
      planId.value = newVal.planId as string
    }
    if (newVal.dataType) {
      dataType.value = newVal.dataType as IPlan.DataType
    }
  }, {
    immediate: true,
    deep: true
  })

  const { data: plans, error, pending, refresh } = useFetch('plans/day', {
    method: 'GET',
    baseURL: runtimeConfig.public.apiUrl + '/esim/v1/',
    transform: (res: {
      success: boolean,
      data: IPlan.DayPlan[]
    }) => {
      if (!res?.success) {
        throw new Error('Failed to fetch day plans')
      }
      return res.data
    }
  })

  const discountRate = computed<number>(() => {
    if (dataType.value === 'special' && plans?.value?.length) {
      const plan = plans?.value?.find(plan => plan.planId === planId.value)
      if (plan) {
        return parseInt(plan.planSpecials?.discount || '0') || 0
      }
    }
    return 0
  })

  return {
    partner,
    planId,
    dataType,
    plans,
    error,
    pending,
    refresh,
    discountRate,
    selectedPlan
  }
})
